import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  linkedSignal,
  untracked,
} from '@angular/core';
import { UptimeClockService } from '../../services/uptime-clock.service';
import { UptimeI18nService } from '../../services/uptime-i18n.service';
import { formatUptime } from '../../utils/format-uptime.function';

@Component({
  selector: 'mon-uptime-timer',
  templateUrl: './uptime-timer.component.html',
  styleUrl: './uptime-timer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UptimeTimerComponent {
  public readonly initialSeconds = input.required<number>();

  private readonly clock = inject(UptimeClockService);
  private readonly i18n = inject(UptimeI18nService);

  private readonly normalizedInitialSeconds = computed(() =>
    Math.max(0, Math.floor(this.initialSeconds())),
  );

  private readonly startedAtTick = linkedSignal({
    source: this.normalizedInitialSeconds,
    computation: () => untracked(() => this.clock.tick()),
  });

  protected readonly display = computed(() => {
    const elapsed = this.clock.tick() - this.startedAtTick();
    const totalSeconds = this.normalizedInitialSeconds() + elapsed;

    return formatUptime(totalSeconds, this.i18n.dayShort());
  });
}
